import React from "react";
import {IonItem, IonList} from "@ionic/react";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../../ts/manager/Manager";
import AppButton from "../../../element/button/AppButton";
import BasicForm from "../../../component/form/BasicForm";
import StateViewController from "../../../vc/StateViewController";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import {FormItem} from "../../../component/form/model/FormModel";
import PasswordInputFIE from "../../../component/form/form-item-element/PasswordInputFIE";


class AccountChangePasswordForm extends BasicForm
{

    getLocalError(formItem: FormItem)
    {
        let localError = super.getLocalError(formItem);
        if (localError)
        {
            return localError;
        }
        const confirmPassword = this.stringItem('confirm_password').getCastValue();
        const password = this.stringItem('password').getCastValue();
        if (formItem.itemID === "password")
        {
            if(!confirmPassword){
                return "Please confirm your password";
            }
        } else if (formItem.itemID === "confirm_password")
        {
            if (confirmPassword)
            {
                if (confirmPassword !== password)
                {
                    return "Passwords do not match";
                }
            }
        }
        return null;
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        return await getManager().api.fetchData("/account/password/update", "POST", params, true).then((responseVO: ApiResponseVO) =>
        {
            if (!responseVO.apiError)
            {
                getManager().user.setLoginToken(responseVO.data.token ?? "")
            }
            return responseVO;
        });
    }

    handleSubmitComplete()
    {
     //  manager.user.dispatchUserUpdateListeners();
    }


    renderComponent()
    {

        return <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.startFormAlerts()}
                            {this.requiredFieldsMessage()}
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <PasswordInputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "old_password",
                                            name: "Current password",
                                            required: true,
                                            errorMessages: {
                                                required: "Please enter your existing password"
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-126">
                                </div>
                                <div className="col-12 col-lg-6">
                                    <PasswordInputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "password",
                                            name: "New password",
                                            required: true,
                                            errorMessages: {
                                                required: "Please enter a password"
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <PasswordInputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "confirm_password",
                                            name: "Confirm password"
                                        }}
                                    />
                                </div>
                            </div>

                            {this.endFormAlerts()}
                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Change Password
                                    </AppButton>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}

const AccountChangePasswordPage = (props:IRouteProps) =>
{

    const viewState = StateViewController({
        routeProps: props
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    return <>
        <section className="content-block">
            <AccountChangePasswordForm
                routeProps={props}
            />
        </section>
    </>
}

export default AccountChangePasswordPage;